import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { Root } from './styled.js';
import styles from './Label.module.css.js';

const Label = React.forwardRef((_a, ref) => {
    var { children, required, className } = _a, props = __rest(_a, ["children", "required", "className"]);
    const theme = useTheme();
    return (React.createElement(Root, Object.assign({}, props, { ref: ref, theme: theme, "$required": required, className: cn([styles['tend-ui-form-label-root'], className]) }), children));
});
Label.displayName = 'Form.Label';

export { Label };
